import React, { Component } from 'react';
import { UncontrolledCollapse, Input, Badge, Container, ListGroup, ListGroupItem, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import { PdfEstadoCuenta } from '../../store/sagas/estadoCuentaApi';
import { notificacion } from '../../utilitarios/util';
import Spinner from "../reusable/Loader";


export class EstadoCuentaDetalle extends Component {
  static displayName = EstadoCuentaDetalle.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isEmpty: false,
      collapse1: false,
      fillActive: 0,
      estadoCuenta: [],
      periodo: {},
      dealer: {},
      linea: {},
      totalCuenta: 0
    };
  }
  checkParams() {
    const { state } = this.props.location;
    let estadoCuentaCollapse = [];
    let total = 0;
    state.estadoCuenta.map((item, index) => {
      estadoCuentaCollapse.push({ cuenta: item, collapse: false });
      total = total + Number((item.impor).toFixed(2));
    })

    this.setState(
      {
        estadoCuenta: estadoCuentaCollapse,//params.estadoCuenta,
        totalCuenta: Number((total).toFixed(2)),
        periodo: state.periodo,
        dealer: state.dealer,
        linea: state.linea,
        isEmpty: (state.estadoCuenta.length > 0) ? false : true,
        loading: false
      });
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { isEmpty, fillActive, loading, periodo, estadoCuenta, collapse1, totalCuenta } = this.state;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Resumen de Estado de Cuenta</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link className="active" to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/estado-cuenta'>Estado de Cuenta</Link></li>
              <li>Resumen</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <button className='btn-icon back mb-4 mobile'>
            <SvgAssets icon="icon-arrow-left" fill={'#fff'} />
          </button>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="estado-cuenta-date" style={{minHeight:'initial'}}>
              <div className="content-left">
                <h5 className='paragraph-1 bold'>ESTADO DE CUENTA<br />{periodo.mes} {periodo.anio}</h5>
              </div>
              <div className="date">
                <div>
                  <span className='paragraph-2 azul light'>Fecha de emisión:</span>
                  <span className='paragraph-2 azul bold'>28/08/2020 20:23:00</span>
                </div>
                <button className="btn-icon"
                  type="button"
                  onClick={() => this.downloadPDF(periodo)}
                >
                  <SvgAssets icon="icon-download-file" fill={c.verdeClaro} />
                </button>
              </div>
            </div>
            <hr className="desktop" />
            <ListGroup flush className="list-group-desktop">
              <ListGroupItem>
                <Row form>
                  <Col xs={6}>
                    <span className='paragraph-3 bold' style={{ color: c.grisMedio }}>Resumen</span>
                  </Col>
                  <Col xs={3}>
                    <span className='paragraph-3 bold' style={{ color: c.grisMedio }}>Soles</span>
                  </Col>
                  <Col xs={3}></Col>
                </Row>
              </ListGroupItem>
              {estadoCuenta.map((item, index) => {
                let colorPill = this.getColorForTab(item.cuenta.codig, data.EstadoCuenta);
                return (
                  <ListGroupItem key={index}>
                    <Row form>
                      <Col xs={6}>
                        <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: colorPill }}>{item.cuenta.glosa}</span>
                      </Col>
                      <Col xs={4}>
                        <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: colorPill }}>{item.cuenta.importe}</span>
                      </Col>
                      <Col xs={2} className="text-right">
                        <button className="btn-icon" id={`toggler-${index}`}>
                          <SvgAssets icon="icon-bottom" fill={colorPill} />
                        </button>
                      </Col>
                    </Row>
                    <UncontrolledCollapse toggler={`#toggler-${index}`}>
                      <ListGroup flush>
                        <ListGroupItem>
                          <Row form>
                            <Col xs={3}>
                              <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: colorPill }}>Doc.</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: colorPill }}>Número</span>
                            </Col>
                            <Col xs={3} className="text-right">
                              <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: colorPill }}>Día</span>
                            </Col>
                            <Col xs={3} className="text-right">
                              <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: colorPill }}>Importe S/</span>
                            </Col>
                          </Row>
                        </ListGroupItem>
                        {item.cuenta.item.map((item, index) => {
                          return (
                            <ListGroupItem>
                              <Row form>
                                <Col xs={3} md={3}>
                                  <span className='paragraph-3' style={{ color: c.grisMedio }}>{item.docum}</span>
                                </Col>
                                <Col xs={4} md={3}>
                                  <span className='paragraph-3' style={{ color: c.grisMedio }}>{item.xblnr}</span>
                                </Col>
                                <Col xs={2} md={3} className="text-right">
                                  <span className='paragraph-3' style={{ color: c.grisMedio }}>{item.dia}</span>
                                </Col>
                                <Col xs={3} className="text-right">
                                  <span className='paragraph-3' style={{ color: c.grisMedio }}>{(Number(item.impor)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
                                </Col>
                              </Row>
                            </ListGroupItem>
                          )
                        })
                        }
                        {/* <ListGroupItem>
                          <Row form>
                            <Col xs={3}>
                              <span className='paragraph-3 bold' style={{ color: c.rojoClaro }}>Documento</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3 bold' style={{ color: c.rojoClaro }}>Número</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3 bold' style={{ color: c.rojoClaro }}>F. Emisión</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3 bold' style={{ color: c.rojoClaro }}>Importe S/</span>
                            </Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row form>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>Factura de Detracción</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>3100028148</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>21/08/2019</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>1,200.08</span>
                            </Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row form>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>Factura de Detracción</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>3100028148</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>21/08/2019</span>
                            </Col>
                            <Col xs={3}>
                              <span className='paragraph-3' style={{ color: c.grisMedio }}>1,200.08</span>
                            </Col>
                          </Row>
                        </ListGroupItem> */}
                      </ListGroup>
                    </UncontrolledCollapse>
                  </ListGroupItem>
                );
              })}
              {/* <ListGroupItem>
                <Row form>
                  <Col xs={6}>
                    <span className='paragraph-3 bold' style={{ color: c.morado }}>Depósito pendiente de aplicar</span>
                  </Col>
                  <Col xs={4}>
                    <span className='paragraph-3 bold' style={{ color: c.morado }}>S/ 19,720.07</span>
                  </Col>
                  <Col xs={2}>
                    <button className="btn-icon" id="toggler-2">
                      <SvgAssets icon="icon-bottom" fill={c.morado} />
                    </button>
                  </Col>
                </Row>
                <UncontrolledCollapse toggler="#toggler-2">
                  <ListGroup flush>
                    <ListGroupItem>
                      <Row form>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.morado }}>Doc. Depósito</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.morado }}>Operación</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.morado }}>F. Depósito</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.morado }}>Importe S/</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row form>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>2018-1300-1100016709</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>op.03015824</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>23/03/2018</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>5.22</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row form>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>2018-1300-1100016709</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>op.03015824</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>23/03/2018</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>5.22</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  </ListGroup>
                </UncontrolledCollapse>
              </ListGroupItem>
              <ListGroupItem>
                <Row form>
                  <Col xs={6}>
                    <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>Facturas de anticipo</span>
                  </Col>
                  <Col xs={4}>
                    <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>S/ 19,720.07</span>
                  </Col>
                  <Col xs={2}>
                    <button className="btn-icon" id="toggler-3">
                      <SvgAssets icon="icon-bottom" fill={c.verdeClaro} />
                    </button>
                  </Col>
                </Row>
                <UncontrolledCollapse toggler="#toggler-3">
                  <ListGroup flush>
                    <ListGroupItem>
                      <Row form>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>Documento</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>Número</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>F. Emisión</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3 bold' style={{ color: c.verdeClaro }}>Importe S/</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row form>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>Factura de Detracción</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>3100028148</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>23/03/2018</span>
                        </Col>
                        <Col xs={3}>
                          <span className='paragraph-3' style={{ color: c.grisMedio }}>1,200.08</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  </ListGroup>
                </UncontrolledCollapse>
              </ListGroupItem> */}
            </ListGroup>
            <p className="total-price">TOTAL: S/ {(Number(totalCuenta)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</p>
          </div>
        </Container>
      </div>
    );
  }
  ToggleCollapse1 = (index) => {
    this.state.estadoCuenta[index].collapse = !this.state.estadoCuenta[index].collapse
    this.setState({ estadoCuenta: this.state.estadoCuenta })
  }

  downloadPDF = (periodo) => {
    this.postPdfEstadoCuenta(
      this.state.dealer.codcliente,
      this.state.dealer.correoElectronico,
      periodo,
      this.state.linea.vkorg,
      this.state.linea.vkorg
    );
  }

  postPdfEstadoCuenta = async (CodigoDealer, CorreoElectronicoDealer, periodo, Bukrs, Vkorg) => {
    this.setState({ loading: true });

    PdfEstadoCuenta(CodigoDealer, CorreoElectronicoDealer, periodo.anio, Bukrs, Vkorg, periodo.id)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });

          if (result.dto.urlPdf == null || result.dto.urlPdf == "") {
            notificacion("Estados cuenta Detalle", "No existe documento a descargar" ?? null);
          }
          else {
            window.open(result.dto.urlPdf, '_blank');
            // Linking.openURL(result.dto.urlPdf).catch(err => console.log("Couldn't load page", err));
          }

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Estados cuenta Detalle", error.message ?? null);
        });
      });
  }

  getColorForTab = (codigo, estado) => {

    switch (codigo) {
      case estado.DocumentoPendientePago:
        return c.rojoClaro;
      case estado.DepositoPendienteAplicar:
        return c.morado;
      case estado.FacturaAnticipo:
        return c.verde;
      default:
        return c.rojoClaro;
    }
  }
}
